import React from "react";
import BlogBanner from "../../../components/NZComponent/NzBlog/BlogBanner";
import BlogCard from "../../../components/NZComponent/NzBlog/BlogCard";
import { blogService } from "../../../services/blogService";
import { useRegion } from "../../../context/RegionContext";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";

const UsBlog = () => {
    const { region } = useRegion();
    const seoData = seoConfig.us.blog;
    const [blogs, setBlogs] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        blogService.getBlogSummaries(region)
            .then(data => {
                setBlogs(data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching blogs:", err);
                setLoading(false);
            });
    }, [region]);

    return (
        <div className="min-h-screen">
            <SEOMetadata
                title={seoData.title}
                description={seoData.description}
                keywords={seoData.keywords}
            />

            <BlogBanner />
            <div className="pt-[20px] pb-[20px] bg-white">
                <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
                    <div className="bg-white min-h-[400px]">
                        <div className="custom-container">
                            {loading ? (
                                <div className="flex justify-center py-20">
                                    <div className="loader"></div>
                                </div>
                            ) : (
                                <>
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
                                        {blogs.map((blog) => (
                                            <BlogCard key={blog.WPTextBlockId} blog={blog} />
                                        ))}
                                    </div>

                                    {blogs.length === 0 && (
                                        <div className="text-center py-20">
                                            <h2 className="kuunari-bold text-3xl text-[#333] mb-4">NO STORIES YET</h2>
                                            <p className="montserrat-regular text-gray-600">We're out on an adventure. Check back soon for new updates!</p>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UsBlog;
